<template>
  <div class="pay">
    <ul class="bread f-dpf">
      <li class="bread-it actived">
        确认订单
        <i class="bread-ic"><span>1</span></i>
      </li>
      <li class="bread-it active">
        支付
        <i class="bread-ic"><span>2</span></i>
      </li>
      <li class="bread-it">
        获取注册码
        <i class="bread-ic"><span>3</span></i>
      </li>
    </ul>

    <div class="pay-it">
      <div class="pay-cnt f-tac">
        <div class="radio-bx">
          <h3 class="f-tal">支付方式</h3>
          <div class="radio-pay">
            <el-radio-group v-model="payType" @change="selectPayType" :disabled="radioIsdisable">
              <el-radio label="2" border>微信支付</el-radio>
              <el-radio label="1" border>支付宝支付</el-radio>
              <el-radio label="3" border>对公转账</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="pay-detail">
          <i
            class="el-icon-loading f-center"
            v-if="radioIsdisable === true"
            style="font-size: 40px"
          ></i>
          <template v-else>
            <div class="qr" v-if="payType != 3">
              <!-- <vue-qr :text="payTypeInfo.content" :callback="test" qid="testid"></vue-qr> -->
              <vue-qr :text="qrLink" qid="testid"></vue-qr>
              <div class="btn-bx">
                <el-button
                  class="btn-org btn"
                  type="primary"
                  :plain="true"
                  @click="getOrderDetails"
                  :loading="btnLoading"
                  >支付成功</el-button
                >
              </div>
            </div>

            <div class="pay-it3" v-if="payType == 3">
              <p>
                <span>公司名称：</span
                >{{ bankInformation.content && bankInformation.content.company_name }}
              </p>
              <p>
                <span>开户银行名称：</span
                >{{ bankInformation.content && bankInformation.content.bank_name }}
              </p>
              <p>
                <span>开户银行账号：</span
                ><span class="num" style="font-size: 32px; color: #333; line-height: 1">{{
                  bankInformation.content && bankInformation.content.bank_account
                }}</span>
              </p>
            </div>
            <div class="contact" v-if="payType == 3">
              <h4 class="f-fs28 f-tac" style="margin-bottom: 20px">支付完成后联系我们：</h4>
              <div class="g-cnt f-dpf">
                <div class="img-bx">
                  <img
                    src="https://www.abackup.com/assets/images/icon/wx_dl.png"
                    width="180"
                    height="180"
                    alt=""
                  />
                </div>
                <div class="txt-bx">
                  <h4>微信扫一扫，联系我们工作人员</h4>
                  <p>1.添加时备注公司名称，和支付信息。</p>
                  <p>2.客服人员通过微信把注册码、合同等信息发给您。</p>
                  <p>3.通过邮箱或手机登录当前系统，查看购买详细信息、其他操作等。</p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="contact" v-if="payType != 3">
      <h3 class="f-tac">联系我们</h3>
      <div class="g-cnt f-dpf">
        <div class="img-bx">
          <img
            src="https://www.abackup.com/assets/images/icon/wx_dl.png"
            width="180"
            height="180"
            alt=""
          />
        </div>
        <div class="txt-bx">
          <h4>微信扫一扫，联系我们工作人员</h4>
          <p>联系电话：028-61533037</p>
          <p>联系邮件：aomeitech@163.com</p>
          <p>联系地址：四川省成都市锦江区下沙河铺街59号(联合广场)1栋2单元6层</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.pay {
  padding-top: 25px;
}
.pay-it {
  background: #fff;
  border-radius: 10px;
  padding: 60px;
  .btn-bx {
    text-align: center;
  }
}
.btn-org {
  width: 240px;
  height: 60px;
  font-size: 24px;
}
.el-radio {
  width: 240px;
  height: 80px;
  line-height: 80px;
  background: #f2f2f2;
  border-radius: 10px;
  font-size: 18px;
  &.is-bordered {
    padding: 0 10px;
  }
  .el-radio__inner {
    width: 20px;
    height: 20px;
  }
  span {
    font-size: 18px;
  }
  .el-radio__label {
    font-size: 18px;
  }
}

.pay-detail {
  min-height: 448px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .contact {
    padding: 80px 0 35px;
    max-width: 880px;
    width: 100%;
  }
}

.pay-it3 {
  margin: 60px 0 0;
  width: 100%;
  max-width: 880px;
  background-color: #f5f5f5;
  padding: 46px 60px 32px;
  font-size: 18px;
  text-align: left;
  p {
    margin-bottom: 15px;
  }
}
.qr {
  img {
    width: 300px;
    height: 300px;
    margin: 40px 0;
  }
}

@media (max-width: 992px) {
  .pay-it {
    padding: 20px;
  }
  .el-radio {
    width: 160px;
    height: 50px;
    line-height: 46px;
    margin-right: 0;
    .el-radio__label {
      font-size: 16px;
    }
  }
  .pay-detail {
    min-height: auto;
  }
  .qr img {
    width: 180px;
    height: 180px;
    margin: 0;
  }
  .pay-it3 {
    font-size: 14px;
    padding: 20px;
    margin-top: 30px;
    .num {
      font-size: 16px !important;
    }
  }
  .pay-detail .contact {
    padding: 30px 0;
  }
}
@media (max-width: 992px) {
  .pay {
    padding-top: 0;
  }
}
@media (max-width: 565px) {
  .el-radio {
    transform: scale(0.8);
  }

  .radio-pay .el-radio-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }
  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
  }
}
</style>
<style lang="less">
.radio-pay {
  .el-radio__label {
    font-size: 18px;
  }
}
</style>
<script>
import VueQr from "vue-qr";
import * as api from "../api/api";
import { mapMutations } from "vuex";

export default {
  name: "Pay",
  data: function() {
    return {
      btnLoading: false,
      radioIsdisable: false,
      payType: "2",
      qrLink: ""
    };
  },
  computed: {
    payTypeInfo() {
      return this.$store.state.payType;
    },
    user() {
      return this.$store.state.user;
    },
    bankInformation() {
      let bank = {};
      this.payTypeInfo.forEach((item) => {
        if (item.pay_method == 3) {
          bank = item;
        }
      });
      return bank;
    }
  },
  components: { VueQr },
  methods: {
    // test(dataUrl, id) {
    //   // console.log(dataUrl, id);
    // },
    ...mapMutations([
      "updateOrderInfo",
      "setUser",
      "setPayType",
      "setOrderNumberList",
      "delOrderNumberList",
      "delPayType"
    ]),
    getQrLink() {
      console.log(this.payTypeInfo, "[000000000000000000000000000]", this.payType);
      this.payTypeInfo.forEach((item) => {
        if (item.pay_method == this.payType && item.pay_method != 3) {
          this.qrLink = item.content;
          return;
        }
      });
    },
    getOrderDetails() {
      console.log(this.payTypeInfo.out_trade_no, "###########################");
      this.btnLoading = true;
      api
        .isOrdersListPay({ orders_no: this.$store.state.payOrderNumberoList })
        .then((resp) => {
          if (resp.code == 200) {
            const orderNumber = resp.data.order_no;

            api.queryOrders(orderNumber).then((resp) => {
              if (resp.code == 200) {
                this.updateOrderInfo(JSON.stringify(resp.data));
                this.$router.push({ path: "RegistrationCode" });
                this.delOrderNumberList(); // 提交成功删除订单号列表
                this.delPayType();
              } else if (resp.code == 404) {
                this.$message({
                  showClose: true,
                  message: resp.msg,
                  type: "error"
                });
              } else if (resp.code == 403) {
                this.$message({
                  showClose: true,
                  message: resp.msg,
                  type: "warning"
                });
              }
            });
          } else if (resp.code == 404) {
            this.$message({
              showClose: true,
              message: "订单未支付",
              type: "warning"
            });
          }
        })
        .finally(() => {
          this.btnLoading = false;
        })
        .then();
    },
    selectPayType() {
      console.log(this.payType);
      console.log(this.user, "user");
      // this.user.pay_method = this.payType;
      const user = this.user;
      user.pay_method = this.payType;
      this.setUser(user);
      this.radioIsdisable = true;
      console.log(this.user, "paytypeInfo");
      let isExist = false;

      this.payTypeInfo.forEach((item) => {
        if (item.pay_method == this.payType) {
          isExist = true;
          return;
        }
      });
      if (!isExist) {
        api
          .orders(this.user)
          .then((resp) => {
            // return true;
            if (resp.code == 200) {
              this.setPayType(resp.data);
              this.setOrderNumberList(resp.data.out_trade_no);
              this.getQrLink();
            } else {
              this.$message({
                showClose: true,
                message: resp.msg,
                type: "error"
              });
            }
          })
          .finally(() => {
            this.radioIsdisable = false;
          });
      } else {
        this.radioIsdisable = false;
        this.getQrLink();
      }
      //   console.log(this.$store.state.payType,5555555)
      //   this.getQrLink();
    }
  },
  created() {
    console.log(this.user, "useruser");
    console.log(this.payTypeInfo);
    console.log(this.$store.state.payOrderNumberoList, "新得");
    this.getQrLink();
  },
  mounted() {}
};
</script>
